import { render, staticRenderFns, recyclableRender, components } from "./u-textarea.vue?vue&type=template&id=09988a29&scoped=true&"
var renderjs
import script from "./u-textarea.vue?vue&type=script&lang=js&"
export * from "./u-textarea.vue?vue&type=script&lang=js&"
import style0 from "./u-textarea.vue?vue&type=style&index=0&id=09988a29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09988a29",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-textarea/u-textarea.vue"
export default component.exports